// Custom Validation Rules

jQuery.validator.addMethod('atleast1letter1nonletter', function (value, element) {
    return this.optional(element) || (/[a-z]/i.test(value) && /[^a-z]/.test(value));
}, 'Include at least one letter and at least one non-letter, like a number or special character.');

jQuery.validator.addMethod('isEmailValidationRequired', function (value, element) {
    if ($(element).is(':hidden')) {
        // Ignore hidden fields
        return true;
    }
    return jQuery.validator.methods.email.call(this, value, element);
}, 'Please enter a valid email address.');

/* KEEP ON THE BOTTOM */
/* AFTER ALL VALIDATION RULES ARE DEFINED */

// Load Queued Validation Items
window.tfl_validate = (function ($, validate) {
    // will be used to replace the global object
    var replacement = {
        push: function (items) {
            $(function () {
                $(items[0]).validate(items[1]);
            });
        }
    };
    // run any rules that have been pushed already
    if (validate && validate.length > 0) {
        $.each(validate, function (idx, items) {
            replacement.push(items);
        });
    }
    return replacement;
})(jQuery, window.tfl_validate);
